export default {
  title: 'Manage Contest',
  description: 'Manage your contest settings and details',
  overview:
    'Invite users, manage entrants and customize your contest settings. Everything you need to manage your contest is right here.',
  breadcrumbs: {
    manageContest: 'Manage Contest',
    manageContestDescription: 'Manage your contest settings and details',
  },
  copyInviteLink: 'Copy invite link',
  viewContest: 'View contest',
  navigation: {
    manageContest: {
      title: 'Manage Contest',
      description: 'Manage your contest settings and details',
    },
    invitesManager: {
      title: 'Invites Manager',
      description: 'Invite people to your contest. Track the status of your invites.',
    },
    entrantsManager: {
      title: 'Entrants Manager',
      description: 'Manage your entrants and track their performance.',
    },
    settings: {
      title: 'Settings',
      description: 'Edit contest details and advanced settings.',
    },
    serviceFee: {
      title: 'Pay Service Fee',
      description: 'Pay the service fee for your contest.',
    },
  },
  alerts: {
    serviceFee: {
      paymentDue: 'Payment due',
      paymentOverdue: 'Payment overdue!',
      cancelled: 'Contest cancelled',
      paymentOverdueLong: 'Service fee overdue! Pay now to reactivate contest',
      cancelledLong: 'Service fee unpaid - Contest cancelled',
    },
  },
  serviceFeePage: {
    paymentDueSoon: {
      heading: 'Service fee due soon',
      description:
        'Your contest has a one-time service fee that will need to be paid after your contest starts. We will send you a notification when payment is due.',
    },
    serviceFeedue: {
      heading: 'Service fee payment due now',
      description:
        'Your service fee must be paid in order to keep your contest active. Please contact <link>customer support</link> if you have any questions.',
    },
    paymentOverdue: {
      heading: 'Payment Overdue',
      description:
        'Your contest is locked. Users will be unable to make picks until payment is received. Please pay your service fee now to reactivate your contest. If payment is not received your contest will be permanently cancelled. Contact <link>customer support</link> if you need assistance.',
    },
    contestCancelled: {
      heading: 'Contest Cancelled',
      description:
        'Your service fee payment was not received in time and your contest has been cancelled. This is action is permanent and can not be reversed. Contact <link>customer support</link> if you need assistance.',
    },
    serviceFeePaid: {
      heading: "Service fee was paid, you're all set!",
      description: "Service fee was paid, you're all set! Your contest is active and ready to go.",
    },
    paymentComplete: {
      heading: 'Payment Complete',
      description: 'Thanks for your payment. A receipt has been sent to your email address.',
    },
    seePricing: 'See pricing',
    payServiceFee: 'Pay Service Fee',
    // Receipt labels
    paymentLabel: 'Payment',
    dateLabel: 'Date',
    reviewTransaction: 'Review transaction',
    notifications: {
      alreadyPaid: {
        title: 'Service fee already paid',
        message:
          'The service fee for this contest has already been paid. Your contest is active and ready to go!',
      },
      reviewTransactionError: {
        title: 'Unable to open transaction details',
        message:
          'There was an issue accessing your transaction. Please try again or contact support if the problem persists.',
      },
    },
  },
  serviceFeeModal: {
    serviceFeedue: {
      heading: 'Contest payment due',
      description:
        'Your commissioner needs to pay the service fee for this contest to keep it active. Please contact your commissioner if you have any questions.',
    },
    serviceFeeOverdue: {
      heading: 'Contest is locked',
      description:
        'Your commissioner has not paid the service fee for this contest. Please contact your commissioner and ask them to pay the service fee. If payment is not received by the next Pick Deadline the contest will be cancelled.',
    },
    serviceFeeCancelled: {
      heading: 'Contest was cancelled',
      description:
        'Your commissioner did not pay the service fee for this contest. Please contact your commissioner for more information.',
    },
    commissioner: 'Commissioner',
    dismiss: 'Dismiss',
  },
};
